import { URL_TILE_SEARCH_PARAM } from '../url-tiles';

export const LEARNING_OPPORTUNITY_TILE_SLOT_KEY = 'learning-opportunity.detail';
export const LEARNING_OPPORTUNITY_CREATE_TILE_TYPE = 'v1.learning-opportunity.create';
export const LEARNING_OPPORTUNITY_DETAIL_TILE_TYPE = 'v1.learning-opportunity.detail';
export const LEARNING_OPPORTUNITY_EDIT_TILE_TYPE = 'v1.learning-opportunity.edit';

export const route = {
    patterns: {
        learningOpportunities: '/learning-opportunities-v2',
    },
    searchParams: {
        filtration: {
            skillFilter: 'skillFilter',
            workspaceFilter: 'workspaceFilter',
        },
        navigation: {
            courses: 'courses',
        },
        searchTerm: 'search',
        state: 'state',
        tab: 'tab',
    },
} as const;

export const learningOpportunityDetailsPageUrl = (learningOpportunityId: string): string => {
    const searchParams = new URLSearchParams({
        [URL_TILE_SEARCH_PARAM]: `${LEARNING_OPPORTUNITY_DETAIL_TILE_TYPE}.${learningOpportunityId}`,
    });

    return `${route.patterns.learningOpportunities}?${searchParams.toString()}`;
};
